import {SettingsApp} from "./SettingsApp";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {SettingsOptions} from "./SettingsOptions";
let React = require("react");
let ReactDOM = require("react-dom");


let loader=setInterval(()=>{
    if(document.getElementById('App')==null||(window as any).rnSettings==null)
        return;
    clearInterval(loader);

    let setting=new SettingsOptions().Merge((window as any).rnSettings);
    WpAjaxPost.SetGlobalVar((window as any).rnSettings);

    let settingsOptions=new SettingsOptions().Merge((window as any).rnSettings);
    ReactDOM.render(<SettingsApp SettingOptions={setting}/>, document.getElementById('App'));
},200);